export default {
  'home.title': 'OpenDataLab 为大模型提供高质量的开放数据集',
  'home.titleDesc': '中国大模型语料数据联盟开源数据服务指定平台',

  'home.title2': '引领AI大模型时代的数据开源开放平台',

  'home.platform': '平台能力',
  'home.platformA': '海量优质多模态',
  'home.platformADesc': '覆盖7大主流专题、50+数据类型、1500+任务类型',
  'home.platformB': '数据格式标准化',
  'home.platformBDesc': '标准统一的数据集语言、实现数据标注及数据分布在线可视',
  'home.platformC': '开放共享',
  'home.platformCDesc': '汇聚公开、原创自制、合作共建等多种数据源数据集',
  'home.platformD': '智慧检索',
  'home.platformDDesc': '支持对话式、多维数据集meta信息智能检索',
  'home.platformE': '结构化描述可视化展示',
  'home.platformEDesc': '构建开源智能的数据工具，可对多模态数据集的统一管理和统计分析',
  'home.platformF': '免费高速下载',
  'home.platformFDesc': '国内云端无需VPN，可无限制通过web端、CLI/SDK下载',
  'home.partners': '合作伙伴',

  // 20240307 v4
  'home.recommend.industry': '专题推荐',

  'home.recommend.industry.type': '专题',
  'home.recommend.industry.largeModel.name': '大模型语料联盟',
  'home.recommend.industry.largeModel.name.mobile': '语料联盟',
  'home.recommend.industry.largeModel.desc': '独家开源\n首发优质数据',
  'home.recommend.industry.largeModel.join': '加入联盟',

  'home.recommend.industry.dsdl.name': 'DSDL 标准化',
  'home.recommend.industry.dsdl.desc': '统一规范\n可视化 AI 数据',

  'home.recommend.industry.preChain.name': '预训练',
  'home.recommend.industry.preChain.desc': '启动大模型\n探索丰富多元',

  'home.recommend.industry.fineTuning.name': '微调',
  'home.recommend.industry.fineTuning.desc': '优化大模型\n精选微调集合',

  'home.recommend.industry.evaluation.name': '评测',
  'home.recommend.industry.evaluation.desc': '评价大模型\n全面验证性能',

  'home.recommend.hotList': '榜单推荐',
  'home.recommend.hotList.download': '本周下载榜',
  'home.recommend.hotList.viewCount': '本周查看榜',
  'home.recommend.hotList.recentRelease': '本周首发榜',

  'home.filtering.datasets': '筛选( {num} 个数据集)',
  'home.filtering.all': '全部筛选',

  'home.org.deploy.datasets': '已发布 {num} 个数据集',
  'home.recommend.organization': '合作组织',
  'home.recommend.org.verification': '组织认证',

  'home.section2.title': '数据集数量',
  'home.section5.title': '大模型用户'
};
